import {
  CHART_COLORS_DARK_MODE,
  CHART_COLORS_LIGHT_MODE,
} from '@modules/charts/constants';

export function getChartColor(index: number, isLightMode: boolean) {
  const chartColorsMap = isLightMode
    ? CHART_COLORS_LIGHT_MODE
    : CHART_COLORS_DARK_MODE;

  return chartColorsMap[index % chartColorsMap.length];
}
